import { BaseEntity, isEntityOfType } from ".";
import {
  IGet_characters_character_id_location_ok,
  IGet_characters_character_id_ok,
  IGet_characters_character_id_ship_ok,
} from "../service/esiclient";
import { getCachedCorporationEntity } from "./CorporationEntityCache";
import { getCachedAllianceEntity } from "./AllianceEntityCache";
import moment from "moment";

export class CharacterEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Character";
  }

  async toJson(
    location?: IGet_characters_character_id_location_ok | null,
    ship?: IGet_characters_character_id_ship_ok | null
  ): Promise<Excel.EntityCellValue> {
    const id = this._id;
    const props: Partial<IGet_characters_character_id_ok> = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      // - Image
      entity.properties["image"] = {
        type: Excel.CellValueType.webImage,
        address: `https://images.evetech.net/characters/${id}/portrait?tenant=tranquility&size=256`,
        altText: props.name,
      };
      if (props.birthday) {
        const date = moment(props.birthday);
        entity.properties["birthday"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: date.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      // - Alliance
      if (props.alliance_id) {
        const allianceEntity = await getCachedAllianceEntity(props.alliance_id);
        if (allianceEntity !== null) {
          entity.properties["alliance"] = await allianceEntity.toJson();
          delete entity.properties["alliance_id"];
        }
      }
      // - Corporation
      if (props.corporation_id) {
        const corporationEntity = await getCachedCorporationEntity(props.corporation_id);
        if (corporationEntity !== null) {
          entity.properties["corporation"] = await corporationEntity.toJson();
          delete entity.properties["corporation_id"];
        }
      }
      if (location && location !== null) {
        if (location.solar_system_id) {
          entity.properties["location_solar_system_id"] = {
            type: Excel.CellValueType.formattedNumber,
            basicValue: location.solar_system_id,
            numberFormat: "##0",
          };
        }
        if (location.station_id) {
          entity.properties["location_station_id"] = {
            type: Excel.CellValueType.formattedNumber,
            basicValue: location.station_id,
            numberFormat: "##0",
          };
        }
        if (location.structure_id) {
          entity.properties["location_structure"] = {
            type: Excel.CellValueType.formattedNumber,
            basicValue: location.structure_id,
            numberFormat: "##0",
          };
        }
      }
      if (ship && ship !== null) {
        if (ship.ship_item_id) {
          entity.properties["ship_item_id"] = {
            type: Excel.CellValueType.formattedNumber,
            basicValue: ship.ship_item_id,
            numberFormat: "##0",
          };
        }
        if (ship.ship_name) {
          entity.properties["ship_name"] = {
            type: Excel.CellValueType.string,
            basicValue: ship.ship_name,
          };
        }
        if (ship.ship_type_id) {
          entity.properties["ship_type_id"] = {
            type: Excel.CellValueType.formattedNumber,
            basicValue: ship.ship_type_id,
            numberFormat: "##0",
          };
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
        mainImage: { property: "image" },
      },
      compact: {
        icon: "NotablePeople",
      },
    };

    return entity;
  }
}

export function isCharacterEntity(entity: any): boolean {
  return isEntityOfType(entity, "Character");
}
